export const GRADING_STATUS = {
  in_progress: 'In Progress',
  processed: 'Processed',
  failed: 'Failed',
  not_created: 'Not Created'
};
